const STORAGE_KEY = 'vb_browse_history';
const MAX_ITEMS = 20;
const EXCLUDED_PAGES = new Set(['login', 'register']);

export function readBrowseHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((item) => !EXCLUDED_PAGES.has(item.pageId)) : [];
  } catch {
    return [];
  }
}

export function pushBrowseHistory(entry) {
  if (!entry?.id || !entry?.label) return;
  if (EXCLUDED_PAGES.has(entry.pageId)) return;
  try {
    const prev = readBrowseHistory().filter((item) => item.id !== entry.id);
    const next = [{ ...entry, at: Date.now() }, ...prev].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

export function clearBrowseHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function historyLabelForPage(pageId, opts = {}, t) {
  if (pageId === 'home') return t('mobile.home');
  if (pageId === 'casino') {
    const lobby = opts.casinoLobbyId != null ? Number(opts.casinoLobbyId) : null;
    if (lobby === 48 || opts.casinoTabId === '48') return t('nav.tv');
    if (lobby === 293 || opts.casinoTabId === '293') return t('nav.virtual');
    if (lobby === 284 || opts.casinoTabId === '284') return t('nav.fast');
    if (lobby === 198 || opts.casinoTabId === '198') return t('casino.lobby.live');
    return t('nav.slots');
  }
  if (pageId === 'sport') return opts.sportFilter === 'live' ? t('nav.sportLive') : t('nav.sport');
  if (pageId === 'promos') return t('nav.promos');
  if (pageId === 'help') return t('header.help');
  if (pageId === 'account') {
    if (opts.accountSection === 'responsible') return t('mobile.menu.responsibleGaming');
    if (opts.accountSection === 'cashier') return t('header.deposit');
    return t('header.account');
  }
  if (pageId === 'vip') return 'VIP';
  if (pageId === 'cms') return opts.cmsSlug || 'Info';
  return pageId;
}

export function historyCrumbForPage(pageId, opts = {}, t) {
  if (pageId === 'account' && opts.accountSection) return t('header.account');
  if (pageId === 'casino' && opts.casinoTabId && opts.casinoTabId !== '-1') return t('nav.casino');
  if (pageId === 'sport' && opts.sportFilter) return t('nav.sport');
  return '';
}

export function historyIconKeyForPage(pageId) {
  if (pageId === 'home') return 'home';
  if (pageId === 'casino') return 'casino';
  if (pageId === 'sport') return 'sport';
  if (pageId === 'promos') return 'promos';
  if (pageId === 'help') return 'help';
  if (pageId === 'account') return 'account';
  return 'home';
}
